module.exports = __webpack_public_path__ + "img/25.3c877eb5.jpg";